import template from './entitiesSelectionFilter.html';
import './entitiesSelectionFilter.scss';

export class EntitiesSelectionFilterController {
  search(text) {
    this.onSearch({ text });
  }
  toggleEntity(entity) {
    this.onToggle({
      entity,
      isSelected: this.selectedEntities.includes(entity.id),
    });
  }
}

export default {
  controller: EntitiesSelectionFilterController,
  template,
  bindings: {
    id: '@',
    entities: '<',
    selectedEntities: '<',
    showSearch: '<',
    onSearch: '&',
    onToggle: '&',
    listHeight: '<',
  },
};
